import React, { useState, useEffect } from "react";

import TemporaryDrawer from "../../main/TemporayDrawer";
import Footer from "../../main/Footer";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { Button as ButtonPrime } from "primereact/button";
import Button from "@mui/material/Button";
import { TextField } from "@material-ui/core";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FaturaService from "../../api/services/FaturaService";
import EmpresaService from "../../api/services/EmpresaService";
import {
  getCodEmpUser,
  isAdmin,
  getFiliais,
} from "../../api/services/AuthService";
import moment from "moment";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeaderFilterSearch from "../../main/CardHeaderFilterSearch";
import { motion } from "framer-motion";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ReportFaturaService from "../../api/services/ReportFaturaService";
import { DataTable } from "primereact/datatable";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import BackDrop from "../../backdrop/BackDrop";
import InputMask from "react-input-mask";
import { Column } from "primereact/column";
import Tooltip from "@mui/material/Tooltip";
import Fab from "@mui/material/Fab";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import ClearIcon from "@mui/icons-material/Clear";
import { Tag } from "primereact/tag";
import Tabela from "../../styles/Tabela";

import dayjs from "dayjs";

import "dayjs/locale/pt-br";

import styled from "styled-components";

const Header = styled(Box)`
  margin-top: 10px;
`;

const DialogTitleCliente = styled(DialogTitle)`
  color: #041e42;
`;
const TabelaModal = styled.div`
  height: 300px;
  overflow: auto;
  width: 100%;
  margin-top: 10px;
`;
const Layout = styled.div`
  background-color: white;
  font-weight: bold;
  width: 95%;
  min-height: 500px;
  top: 80px;
  margin-top: 20px;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-top: 100px;
`;

const Titulo = styled(Typography)`
  color: #041e42;
  font-weight: bold;
  width: 100%;
  margin-botton: 20px;
`;
const ListarFatura = () => {
  const [numeroFatura, setNumeroFatura] = useState(
    sessionStorage.getItem("numeroFatura"),
  );
  const [open, setOpen] = useState(false);
  const [faturas, setFaturas] = useState([]);
  const [dataInicio, setDataInicio] = useState(
    sessionStorage.getItem("dataInicio") &&
      sessionStorage.getItem("dataInicio") !== "null"
      ? sessionStorage.getItem("dataInicio")
      : null,
  );
  const [dataFim, setDataFim] = useState(
    sessionStorage.getItem("dataFim") &&
      sessionStorage.getItem("dataFim") !== "null"
      ? sessionStorage.getItem("dataFim")
      : null,
  );
  const [tipoData, setTipoData] = useState(
    sessionStorage.getItem("tipoData") &&
      sessionStorage.getItem("tipoData") !== ""
      ? sessionStorage.getItem("tipoData")
      : "TODAS",
  );
  const [errorMessage, setErrorMessage] = useState("");
  const [openSnack, setOpenSnack] = useState(false);
  const [tipoSnack, setTipoSnack] = useState("");
  const [pagamento, setPagamento] = useState(
    sessionStorage.getItem("pagamento") &&
      sessionStorage.getItem("pagamento") !== ""
      ? sessionStorage.getItem("pagamento")
      : "AMBOS",
  );
  const [empresa, setEmpresa] = useState(
    sessionStorage.getItem("empresa") &&
      sessionStorage.getItem("empresa") !== ""
      ? sessionStorage.getItem("empresa")
      : "",
  );
  const [backdropDialog, setBackdropDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [nomeEmpresa, setNomeEmpresa] = useState("");
  const [codigoEmpresa, setCodigoEmpresa] = useState("");
  const [codigoEmpresaSelecionada, setCodigoEmpresaSelecionada] = useState(
    sessionStorage.getItem("codigoEmpresaSelecionada") &&
      sessionStorage.getItem("codigoEmpresaSelecionada") !== ""
      ? sessionStorage.getItem("codigoEmpresaSelecionada")
      : "",
  );
  const [cnpjEmpresa, setCnpjEmpresa] = useState("");
  const [cpfEmpresa, setCpfEmpresa] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [filial, setFilial] = useState(
    sessionStorage.getItem("filial") && sessionStorage.getItem("filial") !== ""
      ? sessionStorage.getItem("filial")
      : "",
  );
  const [empresaSelecionada, setEmpresaSelecionada] = useState();
  const [selectedFatura, setSelectedFatura] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sorting, setSorting] = useState(false);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 0,
    multiSortMeta: [{ field: "numfat", order: -1 }],
  });

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const faturaService = new FaturaService();
  const empresaService = new EmpresaService();
  let navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin() || sessionStorage.getItem("stored")) listar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleView = () => {
    handleToggle();
    faturaService
      .detalhar({
        invoiceNumber: selectedFatura.numfat,
        empfat: isAdmin()
          ? codigoEmpresaSelecionada
          : getFiliais() && getFiliais().length > 0 && filial
            ? filial
            : getCodEmpUser(),
        dataven: moment(selectedFatura.dataVen).format("DD/MM/YYYY"),
        codest: selectedFatura.codest,
        invoiceType: faturaService
          .removeAcento(selectedFatura.invoiceType)
          .toUpperCase(),
        condpag: selectedFatura.condpag,
        valor: selectedFatura.valor,
      })
      .then((response) => {
        response.data.codest = selectedFatura.codest;
        response.data.condpag = selectedFatura.condpag;
        response.data.possuiBoleto = selectedFatura.possuiBoleto;
        response.data.dataVen = moment(selectedFatura.dataVen).format(
          "DD/MM/YYYY",
        );
        navigate("/detalharFatura", {
          replace: true,
          state: { fatura: response.data },
        });
      })
      .catch((erro) => {
        //setError(true);
      })
      .finally(() => {
        handleClose();
      });
  };

  const service = new ReportFaturaService();

  const downloadPdf = () => {
    setOpen(true);
    service
      .getFile("/getPdf/", {
        invoiceNumber: selectedFatura.numfat,
        empfat: isAdmin()
          ? codigoEmpresaSelecionada
          : getFiliais() && getFiliais().length > 0 && filial
            ? filial
            : getCodEmpUser(),
        dataven: moment(selectedFatura.dataVen).format("DD/MM/YYYY"),
        codest: selectedFatura.codest,
        invoiceType: faturaService
          .removeAcento(selectedFatura.invoiceType)
          .toUpperCase(),
        condpag: selectedFatura.condpag,
        valor: selectedFatura.valor,
      })
      .then((response) => {
        const blobFile = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        let url = window.URL.createObjectURL(blobFile);
        let a = document.createElement("a");
        a.href = url;
        a.download =
          selectedFatura.numfat === 0
            ? "aFaturar.pdf"
            : selectedFatura.numfat + ".pdf";
        a.click();

        showMessage("PDF baixado com sucesso!");
      })
      .catch((erro) => {
        console.log("Error name: ", erro.name);
        console.log("Error message: ", erro.message);
        console.log("Error stack: ", erro.stack);

        showMessage("Erro ao baixar PDF da fatura!", "error");
      })
      .finally(() => {
        setOpen(false);
      });
  };

  const selecionarEmpresa = () => {
    if (!empresaSelecionada) {
      setErrorMessage("Nenhum Cliente Selecionado!");
      setOpenSnack(true);
      setTipoSnack("warning");
    } else {
      setEmpresa(empresaSelecionada.codemp + " - " + empresaSelecionada.nome);
      setCodigoEmpresaSelecionada(empresaSelecionada.codemp);
      setOpenDialog(false);
      setOpenSnack(true);
      setTipoSnack("success");
      setErrorMessage("Empresa " + empresaSelecionada.nome + " selecionada!");
    }
  };

  const showMessage = (message, type = "success") => {
    setErrorMessage(message);
    setTipoSnack(type);
    setOpenSnack(true);
  };

  const downloadPlanilha = () => {
    setOpen(true);
    service
      .getFile("/getCsv/", {
        invoiceNumber: selectedFatura.numfat,
        empfat: isAdmin()
          ? codigoEmpresaSelecionada
          : getFiliais() && getFiliais().length > 0 && filial
            ? filial
            : getCodEmpUser(),
        dataven: moment(selectedFatura.dataVen).format("DD/MM/YYYY"),
        codest: selectedFatura.codest,
        invoiceType: faturaService
          .removeAcento(selectedFatura.invoiceType)
          .toUpperCase(),
        condpag: selectedFatura.condpag,
        valor: selectedFatura.valor,
      })
      .then((response) => {
        const blobFile = new Blob([response.data], { type: "application/csv" });
        let url = window.URL.createObjectURL(blobFile);
        let a = document.createElement("a");
        a.href = url;
        a.download = selectedFatura.numfat + ".cnf";
        a.click();

        showMessage("Arquivo CNF baixado com sucesso!");
      })
      .catch((erro) => {
        console.log("Error name: ", erro.name);
        console.log("Error message: ", erro.message);
        console.log("Error stack: ", erro.stack);

        showMessage("Erro ao baixar CNF da fatura!", "error");
      })
      .finally(() => {
        setOpen(false);
      });
  };

  const downloadBoletoApi = () => {
    setOpen(true);
    service
      .getFile("/getBoletoApi/", {
        invoiceNumber: selectedFatura.numfat,
      })
      .then((response) => {
        const blobFile = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        let url = window.URL.createObjectURL(blobFile);
        let a = document.createElement("a");
        a.href = url;
        a.download = "boleto_fatura_" + selectedFatura.numfat + ".pdf";
        a.click();
        showMessage("Boleto baixado com sucesso!");
      })
      .catch((erro) => {
        showMessage("Boleto não disponível para download!", "error");
      })
      .finally(() => {
        setOpen(false);
      });
  };

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const validarListagemCliente = () => {
    let retorno = true;
    if (!nomeEmpresa && !codigoEmpresa && !cnpjEmpresa && !cpfEmpresa) {
      setErrorMessage(
        "Preencha pelo menos um campo de filtro para realizar a pesquisa de clientes!",
      );
      setOpenSnack(true);

      retorno = false;
    }

    return retorno;
  };

  const findEmpresas = () => {
    if (validarListagemCliente()) {
      setBackdropDialog(true);
      empresaService
        .listarEmpresas({
          codemp: codigoEmpresa === "" ? null : codigoEmpresa,
          nome: nomeEmpresa === "" ? null : nomeEmpresa,
          cnpj: cnpjEmpresa === "" ? null : cnpjEmpresa.replace(/[^\d]+/g, ""),
          cpf: cpfEmpresa === "" ? null : cpfEmpresa.replace(/[^\d]+/g, ""),
        })
        .then((response) => {
          setEmpresas(response.data);
        })
        .catch((erro) => {
          console.log("Error name: ", erro.name);
          console.log("Error message: ", erro.message);
          console.log("Error stack: ", erro.stack);
        })
        .finally(() => {
          handleClose();
          setBackdropDialog(false);
        });
    }
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const saveStorage = () => {
    sessionStorage.setItem("numeroFatura", numeroFatura);
    sessionStorage.setItem(
      "codigoEmpresaSelecionada",
      codigoEmpresaSelecionada,
    );
    sessionStorage.setItem("empresa", empresa);
    sessionStorage.setItem("dataInicio", dataInicio);
    sessionStorage.setItem("dataFim", dataFim);
    sessionStorage.setItem("tipoData", tipoData);
    sessionStorage.setItem("pagamento", pagamento);
    sessionStorage.setItem("stored", true);
    sessionStorage.setItem("filial", filial);
  };

  const validarListagem = () => {
    let retorno = true;
    let message = "";
    if (isAdmin() && !empresa) {
      message += "Selecione a empresa para exibir as faturas!\n";
      retorno = false;
    }
    if ((dataInicio || dataFim) && tipoData === "TODAS") {
      message += "Selecione o Período para pesquisa!\n";
      retorno = false;
    }
    if (tipoData !== "TODAS" && (!dataInicio || !dataFim)) {
      message += "Preencha o Data Início e a Data Fim!\n";
      retorno = false;
    }
    if (!retorno) {
      setErrorMessage(message);
      setOpenSnack(true);
      setTipoSnack("warning");
    }
    return retorno;
  };

  const clear = () => {
    setFaturas([]);
    setNumeroFatura("");
    setTipoData("TODAS");
    setDataInicio(null);
    setDataFim(null);
    setPagamento("AMBOS");
    setEmpresa("");
    setCodigoEmpresaSelecionada("");
    setSelectedFatura(null);
    setFilial("");

    faturaService.clearStorage();
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseDialog = () => {
    setEmpresaSelecionada("");
    setCodigoEmpresa("");
    setEmpresa("");
    setEmpresas([]);
    setOpenDialog(false);
  };

  const clearModal = () => {
    setEmpresaSelecionada("");
    setCodigoEmpresa("");
    setEmpresas([]);
    setNomeEmpresa("");
    setCnpjEmpresa("");
    setCpfEmpresa("");
  };

  const listar = (params) => {
    const effectiveParams = params || lazyParams;
    handleToggle();

    if (validarListagem()) {
      const sortParam = effectiveParams.sortField
        ? [
            {
              field: effectiveParams.sortField,
              order: effectiveParams.sortOrder === 1 ? "ASC" : "DESC",
            },
          ]
        : [{ field: "numfat", order: "DESC" }];

      faturaService
        .listar({
          invoiceNumber: numeroFatura || null,
          invoiceType: "AEREO",
          cancelado: false,
          empfat: isAdmin()
            ? codigoEmpresaSelecionada
            : getFiliais() && getFiliais().length > 0 && filial
              ? filial
              : getCodEmpUser(),
          dataInicio,
          dataFim,
          tipoData,
          pagamento,
          page: effectiveParams.first / effectiveParams.rows,
          size: effectiveParams.rows,
          sort: sortParam,
        })
        .then((response) => {
          setFaturas(response.data.content);
          setTotalRecords(response.data.totalElements);
          saveStorage();
        })
        .catch((erro) => console.error("Erro ao listar faturas:", erro))
        .finally(() => handleClose());
    } else {
      handleClose();
    }
  };

  const handleChangeDataInicio = (newValue) => {
    setDataInicio(newValue);
  };

  const handleChangeDataFim = (newValue) => {
    setDataFim(newValue);
  };

  const clearFieldFornecedor = () => {
    clearModal();
    setEmpresa("");
  };

  const dataFaturaBodyTemplate = (rowData) => {
    return rowData.dataFatura
      ? moment(rowData.dataFatura).format("DD/MM/YYYY")
      : "-";
  };

  const dataVenBodyTemplate = (rowData) => {
    return rowData.dataVen ? moment(rowData.dataVen).format("DD/MM/YYYY") : "-";
  };

  const moneyBodyTemplate = (rowData) => {
    if (rowData.valor === null || rowData.valor === undefined) return "-";

    const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    const formatNumber = new Intl.NumberFormat("pt-BR", options);
    const formattedMoney = formatNumber.format(rowData.valor);

    return (
      <div style={{ textAlign: "right", width: "100%" }}>{formattedMoney}</div>
    );
  };
  const statusBodyTemplate = (rowData) => {
    const status = getPayment(rowData);
    return (
      <Tag
        className="mr-2"
        rounded
        value={
          rowData.numfat === 80076 || rowData.numfat === 82186
            ? "Não"
            : rowData.pago
        }
        severity={status.severity}
        icon={status.icon}
      />
    );
  };

  const getPayment = (rowData) => {
    if (
      rowData.pago === "Sim" &&
      rowData.numfat !== 80076 &&
      rowData.numfat !== 82186
    ) {
      return {
        severity: "success",
        icon: "pi pi-check",
      };
    } else {
      return {
        severity: "danger",
        icon: "pi pi-times",
      };
    }
  };

  return (
    <>
      <TemporaryDrawer />
      <motion.div
        className="reembolso"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open || sorting}
        >
          <CircularProgress style={{ color: "#041E42" }} />
          <CircularProgress color="inherit" />
          <CircularProgress style={{ color: "#041E42" }} />
        </Backdrop>
        <Layout className="container">
          <Header>
            <Titulo variant="h5" gutterBottom component="div">
              LISTAGEM DE FATURAS
            </Titulo>
          </Header>
          <Card sx={{ minWidth: 800, backgroundColor: "#F5F5F5", flexGrow: 1 }}>
            <CardContent>
              <CardHeaderFilterSearch />
              <Box component="form">
                <TextField
                  id="numeroFatura"
                  sx={{ width: 200, backgroundColor: "#FFFF" }}
                  label="Nº Fatura"
                  type="text"
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  size="small"
                  value={numeroFatura}
                  onChange={(event) => {
                    setNumeroFatura(event.target.value);
                  }}
                />
                {/*<FormControl sx={{ m: 1, marginLeft: 2.5, paddingTop: 1 }} variant="outlined">
                                    <InputLabel id="demo-controlled-select-buttons-group">Pagamento</InputLabel>
                                    <Select
                                        labelId="demo-controlled-select-buttons-group"
                                        sx={{ width: 200, backgroundColor: "#FFFF" }}
                                        size="small"
                                        label="Pagamento"
                                        id="selectPagamentos"
                                        value={pagamento}
                                        onChange={(event) => {
                                            setPagamento(event.target.value);
                                        }}
                                    >
                                        <MenuItem value={'AMBOS'}>Ambos</MenuItem>
                                        <MenuItem value={'PAGO'}>Pagos</MenuItem>
                                        <MenuItem value={'ABERTO'}>Pendentes</MenuItem>
                                    </Select>
                                </FormControl>*/}
                {isAdmin() ? (
                  <TextField
                    id="empresaAdmin"
                    sx={{ width: 500, marginLeft: 2, backgroundColor: "#FFFF" }}
                    label="Empresa"
                    type="text"
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    size="small"
                    disabled
                    value={empresa}
                    onChange={(event) => {
                      setEmpresa(event.target.value.replace(/[^0-9.]/g, ""));
                    }}
                  />
                ) : null}
                {isAdmin() ? (
                  <Tooltip title="Clique Para Pesquisar Agência!">
                    <Fab
                      onClick={handleClickOpen}
                      sx={{ m: 1, marginTop: 2, marginLeft: 2 }}
                      variant="contained"
                      color="primary"
                      aria-label="add"
                      size="small"
                    >
                      <AddBusinessIcon />
                    </Fab>
                  </Tooltip>
                ) : null}

                {isAdmin() ? (
                  <Tooltip title="Limpar campo de Agência!">
                    <Fab
                      onClick={clearFieldFornecedor}
                      sx={{ m: 1, marginTop: 2, marginLeft: 1 }}
                      variant="contained"
                      color="primary"
                      aria-label="add"
                      size="small"
                    >
                      <ClearIcon />
                    </Fab>
                  </Tooltip>
                ) : null}

                {!isAdmin() && getFiliais() && getFiliais().length > 0 ? (
                  <FormControl
                    sx={{ m: 1, marginLeft: 2.5, paddingTop: 1 }}
                    variant="outlined"
                  >
                    <InputLabel id="demo-controlled-select-buttons-group">
                      Filial
                    </InputLabel>
                    <Select
                      labelId="demo-controlled-select-buttons-group"
                      sx={{ width: 500, backgroundColor: "#FFFF" }}
                      size="small"
                      label="Filial"
                      id="selectPagamentos"
                      value={filial}
                      onChange={(event) => {
                        setFilial(event.target.value);
                      }}
                    >
                      {getFiliais().map((filial) => (
                        <MenuItem key={filial.codemp} value={filial.codemp}>
                          {filial.codemp + " - " + filial.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : null}
              </Box>
              <Box component="form">
                <FormControl
                  sx={{ width: 200, marginTop: 3 }}
                  variant="outlined"
                >
                  <InputLabel sx={{ marginTop: -1 }} id="labelSelectTipoDatas">
                    Período
                  </InputLabel>
                  <Select
                    labelId="labelSelectTipoDatas"
                    id="selectTipoDatas"
                    value={tipoData}
                    label="periodo"
                    size="small"
                    sx={{ backgroundColor: "#FFFF" }}
                    onChange={(event) => {
                      setTipoData(event.target.value);
                    }}
                  >
                    <MenuItem value={"TODAS"}>Selecione</MenuItem>
                    <MenuItem value={"DATA_EMISSAO"}>Data Emissão</MenuItem>
                    <MenuItem value={"DATA_VENCIMENTO"}>
                      Data Vencimento
                    </MenuItem>
                  </Select>
                </FormControl>
                <LocalizationProvider
                  adapterLocale="pt-br"
                  dateAdapter={AdapterDayjs}
                >
                  <DesktopDatePicker
                    label="Data Início"
                    inputFormat="DD/MM/YYYY"
                    value={dataInicio}
                    minDate={dayjs("2024-02-26")}
                    onChange={handleChangeDataInicio}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        sx={{
                          marginTop: 3,
                          marginLeft: 2.5,
                          backgroundColor: "#FFFF",
                        }}
                        {...params}
                      />
                    )}
                  />
                </LocalizationProvider>
                <LocalizationProvider
                  adapterLocale="pt-br"
                  dateAdapter={AdapterDayjs}
                >
                  <DesktopDatePicker
                    label="Data Fim"
                    inputFormat="DD/MM/YYYY"
                    minDate={dayjs("2024-02-26")}
                    value={dataFim}
                    onChange={handleChangeDataFim}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        sx={{
                          marginTop: 3,
                          marginLeft: 2.5,
                          backgroundColor: "#FFFF",
                        }}
                        {...params}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Box>
              <Button
                sx={{ width: 150, marginTop: 2.5 }}
                onClick={listar}
                color="primary"
                variant="contained"
              >
                Listar
              </Button>
              <Button
                sx={{ width: 150, marginLeft: 2.5, marginTop: 2.2 }}
                onClick={clear}
                color="primary"
                variant="contained"
              >
                Limpar
              </Button>
            </CardContent>
          </Card>
          <Tabela>
            {(faturas && faturas.length > 0) || !isAdmin() ? (
              <Card
                sx={{
                  minWidth: 400,
                  backgroundColor: "#F5F5F5",
                  flexGrow: 1,
                  marginTop: 2,
                  height: 700,
                }}
              >
                <CardContent>
                  <div className="card flex flex-wrap justify-content-center gap-3">
                    <ButtonPrime
                      disabled={!selectedFatura}
                      onClick={handleView}
                      style={{ backgroundColor: "#041E42", float: "left" }}
                      type="button"
                      label="Detalhar"
                      icon="pi pi-eye"
                    />
                    <ButtonPrime
                      disabled={!selectedFatura}
                      onClick={downloadPdf}
                      style={{ marginLeft: 3, float: "left" }}
                      className="p-button-danger"
                      type="button"
                      label="PDF"
                      icon="pi pi-file-pdf"
                    />
                    <ButtonPrime
                      disabled={!selectedFatura}
                      onClick={downloadPlanilha}
                      style={{ marginLeft: 3, float: "left" }}
                      className="p-button-success"
                      type="button"
                      label="CNF"
                      icon="pi pi-file-excel"
                    />
                    <ButtonPrime
                      onClick={downloadBoletoApi}
                      style={{ marginLeft: 3, float: "left" }}
                      disabled={
                        !selectedFatura || // nada selecionado → desabilita
                        // se há fatura selecionada, aplica as regras abaixo
                        (selectedFatura.numfat !== 87402 &&
                          selectedFatura.numfat !== 86960 &&
                          (selectedFatura.pago === "Sim" ||
                            selectedFatura.numfat === 0 ||
                            selectedFatura.valor <= 0))
                      }
                      className="p-button-secondary"
                      type="button"
                      label="Boleto"
                      icon="pi pi-dollar"
                    />
                    <Typography
                      variant="h7"
                      gutterBottom
                      style={{ color: "#041E42", float: "right", marginTop: 5 }}
                    >
                      {selectedFatura
                        ? selectedFatura.numfat !== 0
                          ? "FATURA SELECIONADA: " + selectedFatura.numfat
                          : "PRÈ FATURA SELECIONADA! "
                        : "NENHUMA FATURA SELECIONADA! "}
                    </Typography>
                  </div>
                  <Tabela>
                    <DataTable
                      className="minha-tabela-faturas"
                      value={faturas}
                      selection={selectedFatura}
                      lazy
                      paginator
                      totalRecords={totalRecords}
                      rows={lazyParams.rows}
                      first={lazyParams.first}
                      onPage={(e) => {
                        const updated = {
                          ...lazyParams,
                          first: e.first,
                          rows: e.rows,
                          page: e.first / e.rows,
                        };

                        setLazyParams(updated);
                        setSorting(true);
                        listar(updated);
                        setTimeout(() => setSorting(false), 500);
                      }}
                      sortField={lazyParams.sortField}
                      sortOrder={lazyParams.sortOrder}
                      onSort={(e) => {
                        const updated = {
                          ...lazyParams,
                          sortField: e.sortField,
                          sortOrder: e.sortOrder,
                        };

                        setLazyParams(updated);
                        setSorting(true);
                        listar(updated);
                        setTimeout(() => setSorting(false), 500);
                      }}
                      sortMode="single"
                      emptyMessage="Nenhuma Fatura Encontrada"
                      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                      currentPageReportTemplate="{first} a {last} de {totalRecords}"
                      style={{ color: "#041E42" }}
                      onSelectionChange={(e) => setSelectedFatura(e.value)}
                      dataKey="numfat"
                    >
                      <Column
                        selectionMode="single"
                        headerStyle={{
                          backgroundColor: "#041E42",
                          color: "white",
                          width: "3em",
                        }}
                      />
                      <Column
                        field="numfat"
                        sortable
                        header="Nº Fatura"
                        headerStyle={{
                          backgroundColor: "#041E42",
                          color: "white",
                          textAlign: "center",
                        }}
                      />
                      <Column
                        field="dataFatura"
                        body={dataFaturaBodyTemplate}
                        header="Data Emissão"
                        headerStyle={{
                          backgroundColor: "#041E42",
                          color: "white",
                          textAlign: "center",
                        }}
                      />
                      <Column
                        field="dataVen"
                        body={dataVenBodyTemplate}
                        header="Data Vencimento"
                        headerStyle={{
                          backgroundColor: "#041E42",
                          color: "white",
                          textAlign: "center",
                        }}
                      />
                      <Column
                        field="situacao"
                        header="Situação"
                        headerStyle={{
                          backgroundColor: "#041E42",
                          color: "white",
                          textAlign: "center",
                        }}
                      />
                      <Column
                        field="invoiceType"
                        header="Produto"
                        headerStyle={{
                          backgroundColor: "#041E42",
                          color: "white",
                          textAlign: "center",
                        }}
                      />
                      <Column
                        field="valor"
                        body={moneyBodyTemplate}
                        header="Valor"
                        headerClassName="header-right"
                        bodyStyle={{ textAlign: "right" }}
                      />
                      <Column
                        field="pago"
                        body={statusBodyTemplate}
                        header="Pago"
                        headerStyle={{
                          backgroundColor: "#041E42",
                          color: "white",
                          textAlign: "center",
                        }}
                        bodyStyle={{ textAlign: "center" }}
                      />
                    </DataTable>
                  </Tabela>
                </CardContent>
              </Card>
            ) : null}
          </Tabela>
        </Layout>
        <Snackbar
          open={openSnack}
          autoHideDuration={6000}
          onClose={handleCloseSnack}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={tipoSnack}
            sx={{ width: "100%", whiteSpace: "pre-line" }}
          >
            {errorMessage}
          </Alert>
        </Snackbar>
      </motion.div>
      <Footer />
      <Dialog
        maxWidth="lg"
        fullWidth
        open={openDialog}
        onClose={handleCloseDialog}
      >
        <BackDrop onOpen={backdropDialog}></BackDrop>
        <DialogTitleCliente>PESQUISA DE CLIENTES</DialogTitleCliente>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            sx={{ width: 100 }}
            id="codigo"
            label="Código"
            fullWidth
            variant="standard"
            value={codigoEmpresa}
            onChange={(event) => {
              setCodigoEmpresa(event.target.value);
            }}
          />
          <TextField
            autoFocus
            margin="dense"
            id="empresa"
            label="Empresa"
            sx={{ width: 400, marginLeft: 2 }}
            fullWidth
            variant="standard"
            value={nomeEmpresa}
            onChange={(event) => {
              setNomeEmpresa(event.target.value);
            }}
          />
          <InputMask
            mask="99.999.999/9999-99"
            value={cnpjEmpresa}
            onChange={(event) => {
              setCnpjEmpresa(event.target.value);
            }}
          >
            {(inputProps) => (
              <TextField
                autoFocus
                margin="dense"
                id="cnpj"
                sx={{ width: 200, marginLeft: 2 }}
                label="CNPJ"
                fullWidth
                variant="standard"
              />
            )}
          </InputMask>
          <InputMask
            mask="999.999.999-99"
            value={cpfEmpresa}
            onChange={(event) => {
              setCpfEmpresa(event.target.value);
            }}
          >
            {(inputProps) => (
              <TextField
                autoFocus
                margin="dense"
                id="cpf"
                sx={{ width: 200, marginLeft: 2 }}
                label="CPF"
                fullWidth
                variant="standard"
              />
            )}
          </InputMask>

          <Button
            sx={{ marginTop: 3, marginLeft: 2 }}
            color="primary"
            onClick={clearModal}
          >
            Limpar
          </Button>
          <Button
            sx={{ marginTop: 3, marginLeft: 2 }}
            color="primary"
            onClick={findEmpresas}
          >
            Pesquisar
          </Button>
          <TabelaModal>
            <DataTable
              value={empresas}
              selection={empresaSelecionada}
              paginator
              rows={10}
              onSelectionChange={(e) => setEmpresaSelecionada(e.value)}
              dataKey="codemp"
              responsiveLayout="scroll"
            >
              <Column
                selectionMode="single"
                headerStyle={{ width: "3em" }}
              ></Column>
              <Column field="codemp" header="Código"></Column>
              <Column field="nome" header="Nome"></Column>
              <Column field="cnpj" header="CNPJ"></Column>
              <Column field="cpf" header="CPF"></Column>
            </DataTable>
          </TabelaModal>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleCloseDialog}>
            Cancelar
          </Button>
          {empresas.length > 0 ? (
            <Button color="primary" onClick={selecionarEmpresa}>
              Selecionar
            </Button>
          ) : null}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ListarFatura;
